import React, { type ReactElement } from 'react';

import { Banner } from '@pushwoosh/dumb-components';
import { H1 } from '@pushwoosh/kit-typography';

import { Lang, useLang } from '~/src/polyglot';

import { RootBox, ContainerBox } from './styles';
import type { SuccessPageProps } from './SuccessPage.types';

export function SuccessPage(props: SuccessPageProps): ReactElement {
  const { email } = props;
  const lang = useLang();

  return (
    <RootBox>
      <ContainerBox>
        <H1><Lang message="REGISTER.SUCCESS.TITLE" /></H1>
        <Banner
          type="info"
          view="ghost"
          title={lang({ message: 'REGISTER.SUCCESS.MESSAGE', email })}
        />
      </ContainerBox>
    </RootBox>
  );
}
